/** @jsxImportSource @emotion/react */

import { Button } from "semantic-ui-react";
import { css } from "@emotion/react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useCallback, useRef, useState } from "react";
import { toJpeg, toPng } from "html-to-image";
import useFeature from "../../../Shared/FeatureProvider/useFeature";
import { OrderImageDocument } from "./OrderImageDocument";
import useTracking from "../../../../services/Tracking/useTracking";

export const OrderImagePrintButton = ({ order, format = "png" }) => {

    const { track } = useTracking("order_print_pdf")


    const { isEnabled } = useFeature();
    const { t, ready, i18n } = useTranslation(undefined, { useSuspense: false });
    const containerRef = useRef(null);
    const [isGenerating, setIsGenerating] = useState(false);

    const normalizedFormat = format === "jpg" || format === "jpeg" ? "jpg" : "png";

    const handleDownload = useCallback(async () => {
        if (!containerRef.current) {
            return;
        }

        setIsGenerating(true);
        try {
            const dataUrl = normalizedFormat === "jpg"
                ? await toJpeg(containerRef.current, { quality: 0.95, backgroundColor: "#ffffff", cacheBust: true })
                : await toPng(containerRef.current, { backgroundColor: "#ffffff", cacheBust: true });
            track('DOWNLOAD_ORDER_IMAGE', {orderId: order.id});
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `order_${order.displayId}.${normalizedFormat}`;
            link.click();
        } finally {
            setIsGenerating(false);
        }
    }, [normalizedFormat, order.displayId]);

    if (!ready || !isEnabled("order_print_pdf")) {
        return null;
    }
    return (
        <>
            <Button
                icon="file image outline"
                basic
                color="teal"
                loading={isGenerating}
                disabled={isGenerating}
                onClick={handleDownload}
            >
                {t("order.pdf.download_button_label")}
            </Button>
            <div
                aria-hidden="true"
                css={css`
                    position: fixed;
                    top: 200px;
                    left: -10000px;
                    width: 600px;
                    background: #ffffff;
                    z-index: -1;
                `}
            >
                <div ref={containerRef} >
                     <I18nextProvider i18n={i18n}>
                    <OrderImageDocument order={order} />
                </I18nextProvider>
                </div>
               
            </div>
        </>
    )
};

export const OrderImagePreview = ({ order }) => {
    const { ready, i18n } = useTranslation(undefined, { useSuspense: false });
    if (!ready) {
        return null;
    }
    return (
        <div
            css={css`
                width: 100%;
            `}
        >
            <I18nextProvider i18n={i18n}>
                <OrderImageDocument order={order} />
            </I18nextProvider>
        </div>

    )
}
